import { Link } from 'react-router-dom';
import { Container } from '@dma/ui';
import type { MineralDto } from '../../minerals/application/dto/MineralDto';
import './ProductsPreview.css';

export interface ProductsPreviewProps {
  minerals: MineralDto[];
}

export function ProductsPreview({ minerals }: ProductsPreviewProps) {
  return (
    <section className="dma-products-preview" aria-labelledby="dma-products-preview-heading">
      <Container>
        <h2 id="dma-products-preview-heading">محصولات</h2>

        {minerals.length === 0 ? (
          <p className="dma-products-preview__empty">هنوز محصولی ثبت نشده است.</p>
        ) : (
          <div className="dma-products-preview__grid">
            {minerals.map((mineral) => (
              <Link key={mineral.id} to={`/minerals/${mineral.slug}`} className="dma-products-preview__card">
                {mineral.images[0] ? (
                  <img src={mineral.images[0]} alt={mineral.name} loading="lazy" />
                ) : (
                  <div className="dma-products-preview__card-placeholder" aria-hidden="true" />
                )}
                <span>{mineral.name}</span>
              </Link>
            ))}
          </div>
        )}

        <Link to="/minerals" className="dma-products-preview__link">
          مشاهده همه محصولات ←
        </Link>
      </Container>
    </section>
  );
}
